import './App.css';
import { CycleOfFifthsChart, KeyCentre } from './components/CycleOfFifthsChart';
import { WordCloud } from './components/WordCloud';
import { Col, Container, Row } from 'reactstrap';
import { catalog } from './catalog/Catalog';
import { Song } from './catalog/Song';
import { useLocalStorage } from 'react-use-storage';

const distinct = (categories: string[]) => {
  return categories.filter((n, i) => categories.indexOf(n) === i);
}

class Category {
  constructor(
    public keyCentre: KeyCentre,
    public keySignatures: string[],
  ) {}
}

const categories = [
  new Category("C", [ "C" ]),
  new Category("F", [ "F" ]),
  new Category("Bb", [ "BFlat", "ASharp" ]),
  new Category("Eb", [ "EFlat", "DSharp" ]),
  new Category("Ab", [ "AFlat", "GSharp" ]),
  new Category("C#", [ "DFlat", "CSharp" ]),
  new Category("F#", [ "GFlat", "FSharp" ]),
  new Category("B", [ "B" ]),
  new Category("E", [ "E" ]),
  new Category("A", [ "A" ]),
  new Category("D", [ "D" ]),
  new Category("G", [ "G" ]),
];

type MajorMinor =
  "Major" |
  "Minor";

class Bin {
  constructor(
    public keyCentre: KeyCentre,
    public count: number)
  {}
}

const songsCount = (songs: Song[], style: string) => {
  return songs.filter(song => song.style === style).length;
}

const songsFilter = (songs: Song[], styles: string[]) => {
  return songs
    .filter(song => styles.includes(song.style));
}

const keySignaturesCount = (songs: Song[], majorMinor: MajorMinor[], keySignatures: string[]): number => {
  var allKeys = keySignatures.flatMap(keySignature => majorMinor.map(majorMinor => `${keySignature}${majorMinor}`));
  return songs.filter(
    song => allKeys.includes(song.keySignature)
  ).length;
}

const allStyles = distinct(catalog.map(song => song.style))
  .filter(style => songsCount(catalog, style) > 10)
  .sort((a, b) => a.localeCompare(b));

function App() {

  const [ selectedStyles, setSelectedStyles ] = useLocalStorage<string[]>("selectedStyles", allStyles);

  var filteredSongs = songsFilter(catalog, selectedStyles);
  var majorBins = categories.map(category => new Bin(category.keyCentre, keySignaturesCount(filteredSongs, [ "Major" ], category.keySignatures)));
  var majorTotalCount = majorBins.reduce((runningCount, bin) => runningCount + bin.count, 0);
  var minorBins = categories.map(category => new Bin(category.keyCentre, keySignaturesCount(filteredSongs, [ "Minor" ], category.keySignatures)));
  var minorTotalCount = minorBins.reduce((runningCount, bin) => runningCount + bin.count, 0);

  return (
    <div className="App">
      <Container>
        <Row>
          <Col md="4">
            <h2>Musical styles</h2>
            <WordCloud
              onChange={selectedStyles => setSelectedStyles(selectedStyles)}
              words={allStyles}
              selectedWords={selectedStyles}/>
            <hr/>
          </Col>
          <Col md="8">
            <h2>Key signatures</h2>
            <p>{majorTotalCount} songs (major keys)</p>
            <CycleOfFifthsChart width={320} height={320} counts={majorBins}/>
            <hr/>
            <p>{minorTotalCount} songs (minor keys)</p>
            <CycleOfFifthsChart width={320} height={320} counts={minorBins}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;